import React, { Fragment, useEffect, useState } from 'react';
import { ReactComponent as DetailsIcon } from 'assets/icons/details.svg';
import { Outlet, useNavigate } from 'react-router-dom';
import RightSidebar from 'components/right-sidebar';
import { ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import BottomNavigation from 'components/bottom-navigation';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { handleApiError } from 'utils/functions';
import useSectionFormContext from 'contexts/section-form.context';

const ManageSectionFormContent = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const SectionFormDetailsNav = [
    {
      title: 'Details',
      link: `${ROUTE_KEYS.MANAGE_SECTIONS_SIDEBAR_PATH}/${ROUTE_KEYS.MANAGE_CREATE_SECTION}`,
      Icon: DetailsIcon
    }
  ];
  const { setRightSection, activeCokitchen } = useDashboardContext();
  const { disabled, sectionForm } = useSectionFormContext();

  useEffect(() => {
    setRightSection(<RightSidebar title='Section Information' list={SectionFormDetailsNav} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const payload = {
        section_name: sectionForm.sectionName,
        cokitchen_id: activeCokitchen.cokitchen_id,
        brands: sectionForm.selectedBrand,
        meals: sectionForm.selectedItems,
        image_url: sectionForm.images[0],
        polygons: sectionForm.selectedPolygon.map((polygon) => polygon.id),
        is_active: sectionForm.status,
        section_type: 'home',
        position: 0
      };

      const res = await apiService.post('internal/sections', {
        data: payload,
        isInternal: true
      });
      toast(<ToastMessage type='success' message={res.data.message} />);
      navigate(ROUTE_KEYS.MANAGE_SECTIONS);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Outlet />
      <div className='mx-10 pb-8 max-w-[700px]'>
        <BottomNavigation
          loading={loading}
          list={SectionFormDetailsNav}
          onConfirm={handleConfirm}
          disabled={disabled}
        />
      </div>
    </Fragment>
  );
};

export default ManageSectionFormContent;
